class Module {
    deviceType= "module";
    code= "";
    description= "";
    manufacturer= "";
     warranty= 12;
    performanceWarranty= 30;
    dcPowerWp= 330;
    dcPower= 0.33;
    voc= 46.1;
    vmp = 37.3;
    isc= 9.29;
    imp=  8.85;
    coefVoc = 0.32; //unit (-%/C)
    coefVmp = 0.32;//unit (-%/C)
    coefIsc = 0.05;
    coefPmp = 0.4;//unit (-%/C)
    efficiency= 17.02;
    weight = 22.5;
    height = 1960;
    width = 991;
    depth = 35;
    //Starting the first year      
    performanceOverYears  =[98,97.55,97.1,96.65,96.2,95.75,95.3,94.85,94.4,93.95,93.5,93.05,92.6,92.15,91.7,91.25,90.8,90.35,89.9,89.45,89,88.55,88.1,87.65,87.2,86.75,86.3,85.85,85.4,84.95]

    unit = "peça (s)";
    product = { 
      price:0,
      priceTarget:0,
      cost:0,
     // taxes:0,
      sellerId:"", //Now its a string
      available:true, //editted by the user
      unit : "peça (s)",
      quantity:0,
      // rules:[
      //         {userProfile:1234, read:true}
      // ]
      rules: "true",
      we:{
        ativoMatriz:false,
        ativoIntegrador:false,
        ativoFranquia:false,
        custoUsdAtivo:false,
        custoUsd:0,
        precoTargetUsd:0,

      }
      

   };

    constructor() {
    };
    clone(object){
      // var self = this;
      // self = Object.assign(self , object);
      Object.assign(this, object );
    }

    // loadFromModule(m){
    //   var self = this;
    //   self = Object.assign(self , m);
      
    //   // this.id= m.id;
    //   // this.deviceType= "module";
    //   // this.code= m.code;
    //   // this.description= m.description;
    //   // this.manufacturer= m.manufacturer;
    //   //   this.warranty= m.warranty;
    //   //   this.performanceWarranty= m.performanceWarranty;
    //   // this.dcPower= m.dcPower;
    //   // this.dcPowerWp= m.dcPowerWp;
    //   // this.voc= m.voc;
    //   // this.vmp = m.vmp;
    //   // this.isc= m.isc;
    //   // this.imp=  m.imp;
    //   // this.coefVoc = m.coefVoc;
    //   // this.coefVmp = m.coefVmp;
    //   // this.coefIsc = m.coefIsc;
    //   // if(m.coefPmp)
    //   //   this.coefPmp =m.coefPmp;
    //   // if(m.coefpmp)
    //   //   this.coefPmp =m.coefpmp;
    //   // this.efficiency= m.efficiency;
    //   // this.weight = m.weight;
    //   // this.height = m.height;
    //   // this.width = m.width;
    //   // this.depth = m.depth;
    //   // if(m.unit)
    //   //   this.unit = m.unit;
    //   // this.product = m.product;

    // };

    loadFromModulo(m){
      this.deviceType= "module";
      this.code= m.codigo;
      this.description= m.descricao;
      this.manufacturer= m.fabricante;
      if(m.garantia)
        this.warranty= m.garantia;
      if(m.garantiaEficiencia)
        this.performanceWarranty= m.garantiaEficiencia;

      this.dcPower= m.potenciaDc;
      this.dcPowerWp = this.dcPower*1000;

      this.voc= m.voc;
      this.vmp = m.vmp;
      this.isc= m.isc;
      if(m.imp)
        this.imp=  m.imp;

      this.coefVoc = m.coefVoc;
      this.coefVmp = m.coefVmp;
      this.coefIsc = m.coefIsc;
      if(m.coefPmp)
        this.coefPmp =m.coefPmp;
      if(m.coefpmp)
        this.coefPmp =m.coefpmp;
  
      this.efficiency= m.eficiencia;
      this.weight = m.peso;
      this.height = m.altura;
      this.width = m.largura;
      this.depth = m.profundidade;
      
      if(m.unidade)
        this.unit = m.unidade;
      else
        this.unit= 'peça(s)'


      if(m._id){
        //alert(JSON.stringify(m._id))
        this.id = m._id.$oid;
      }else{
        alert(JSON.stringify(m._id))
        
      }
        
      
      this.product.priceTarget = m.precoTarget;
      this.product.cost = m.custo; 
      this.product.sellerId = m.fabricante;
      this.product.crmId=m.ploomesId;
      this.product.erpId = m.codRef;
      
      this.product.we.ativoFranquia= m.ativoFranquia;
      this.product.we.ativoIntegrador = m.ativoIntegrador;
      this.product.we.ativoMatriz= m.ativoMatriz;
      if(m.custoUsdAtivo){
        this.product.we.custoUsdAtivo = m.custoUsdAtivo;
        this.product.we.custoUsd= m.custoUs;
        this.product.we.precoTargetUsd = m.precoTargetUsd;
      }
      
      
    };

    calc(){
        console.log(`Dimendions  height: ${this.height}  + width:${this.width}`)
      //  var m = new Modulo;
    
    }

    //calular inversor
}




export default Module;
